import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChallengeAnswer, ChallengeQuestion, IForgotData, IUpdateObject } from 'app/core/user/updateObject.model';
import { SERVER_API_URL } from 'app/app.constants';
import { IFirstLogin, IUser } from 'app/core';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _userToVerify: IUser;
    private _pwdtoChange: IUpdateObject;
    private _timeoutOTP: number;

    constructor(private http: HttpClient) {}

    get pwdtoChange(): IUpdateObject {
        return this._pwdtoChange;
    }

    set pwdtoChange(value: IUpdateObject) {
        this._pwdtoChange = value;
    }

    get userToVerify(): IUser {
        return this._userToVerify;
    }

    set userToVerify(value: IUser) {
        this._userToVerify = value;
    }

    get timeoutOTP(): number {
        return this._timeoutOTP;
    }

    set timeoutOTP(value: number) {
        this._timeoutOTP = value;
    }

    isUserLoggedParams(appUrl: string): Observable<any> {
        return this.http.get(SERVER_API_URL + '/private/login', {
            params: new HttpParams().set('appUrl', appUrl)
        });
    }

    setUserToVerify(outObj: IUser): IUser {
        return (this._userToVerify = outObj);
    }

    getUserToVerify(): IUser {
        return this._userToVerify;
    }

    isUserLogged(): Observable<any> {
        return this.http.get(SERVER_API_URL + '/private/login', null);
    }

    changePassword(outObj: IUpdateObject): Observable<HttpResponse<any>> {
        return this.http.post(SERVER_API_URL + 'api/user/changePassword', outObj, { observe: 'response' });
    }

    changePin(outObj: number): Observable<HttpResponse<any>> {
        return this.http.post(SERVER_API_URL + 'api/user/changePin', { newPin: outObj }, { observe: 'response' });
    }

    updateUser(outObj: IUser): Observable<HttpResponse<any>> {
        return this.http.post(SERVER_API_URL + 'api/user/changeUserInformation', outObj, { observe: 'response' });
    }

    firstLogin(outObj: IFirstLogin): Observable<HttpResponse<any>> {
        return this.http.post(SERVER_API_URL + 'api/user/firstLogin', outObj, { observe: 'response' });
    }

    confirmForgotPasswordRequest(outObj: ChallengeAnswer): Observable<HttpResponse<any>> {
        return this.http.post(SERVER_API_URL + 'api/forgotCredential/user/forgotPassword', outObj, { observe: 'response' });
    }

    confirmForgotUsernameRequest(outObj: ChallengeAnswer): Observable<HttpResponse<any>> {
        return this.http.post(SERVER_API_URL + 'api/forgotCredential/user/forgotUsername', outObj, { observe: 'response' });
    }

    requestCaptcha(id: string): Observable<HttpResponse<Blob>> {
        return this.http.get(SERVER_API_URL + 'captcha', {
            params: new HttpParams().set('id', id),
            observe: 'response',
            responseType: 'blob'
        });
    }

    requestCaptchaSound(id: string): Observable<HttpResponse<Blob>> {
        return this.http.get(SERVER_API_URL + 'captcha-sound', {
            params: new HttpParams().set('id', id),
            observe: 'response',
            responseType: 'blob'
        });
    }

    proceedForgotCredential(outObj: IForgotData): Observable<HttpResponse<any>> {
        return this.http.post(SERVER_API_URL + 'api/forgotCredential/user/getChallengeQuestion', outObj, { observe: 'response' });
    }

    checkPasswordless(forgotData: IForgotData): Observable<HttpResponse<any>> {
        return this.http.post(SERVER_API_URL + 'api/forgotCredential/user/checkPasswordless', forgotData, { 
            observe: 'response'
        });
    }

    logoutToChangeProfile(): Observable<any> {
        return this.http.get(SERVER_API_URL + 'private/logoutToChangeProfile');
    }

    generateOTP(outObj: IUser): Observable<any> {
        return this.http.post(SERVER_API_URL + 'api/user/generateOTP', outObj, { observe: 'response' });
    }

    reloadOTP(outObj: IUser): Observable<any> {
        return this.http.post(SERVER_API_URL + 'api/user/reloadOTP', outObj, { observe: 'response' });
    }

    getLogged(): Observable<HttpResponse<IUser>> {
        return this.http.get<IUser>(SERVER_API_URL + 'api/user/logged', { observe: 'response' });
    }

    logout(): Observable<HttpResponse<any>> {
        return this.http.post(SERVER_API_URL + 'api/user/logout', null, { observe: 'response', responseType: 'text' });
    }

    getUserType(): Observable<string> {
        return this.http.get<string>(SERVER_API_URL + 'api/user/type');
    }

    getUserTypeWarning(userType: string): Observable<string> {
        return this.http.get(SERVER_API_URL + 'api/user/warning/' + userType, { responseType: 'text' as 'text' })
            .pipe(map((res: any) => (res === null || res === undefined ? '' : '' + res)));
    }
}
